import React from "react";
import { connect } from "react-redux";
import routes from "../../../assets/apiRoutes.json"
import Popup from 'devextreme-react/popup';
import ScrollView from "devextreme-react/scroll-view";
import { GridLayout } from "../../../common/GridLayout";
import { Localization } from "../../../common/Localization";
import axios from "axios";
import DataGrid, {
    Column,
    Editing,
    Paging,
    RequiredRule,
    StringLengthRule,
    Toolbar,
    Item,
    FilterRow,
    FilterPanel,
    FilterBuilderPopup,
    ColumnChooser,
    ColumnChooserSearch,
    ColumnFixing,
    Sorting,
    Export,
    Pager,
    HeaderFilter,
    Lookup,
    StateStoring
} from 'devextreme-react/data-grid';
import { Button } from 'devextreme-react/button';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import AddRametCodes from './AddRametCodes'
import UploadRametCodes from "./UploadRametCodes";
import GridLayoutManager from "../../../gridLayoutCustomization/GridLayoutManager";
import {
    OrchardTypeArr,
    ElevationArr,
    SpeciesArr,
    BlockCycleArr,
    StimCycleArr,
    StimStatusArr,
    BreedingAreaArr,
    PositionArr
  } from '../const/StaticData';

const filterBuilderPopupPosition = {
    of: window,
    at: 'top',
    my: 'top',
    offset: { y: 10 },
};

const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
const dataGrid = React.createRef();
let accessToken = '';

const gridKey = "aa2f66fe-b121-477b-b70f-635822c3b7ac";

class RametCodesGrid extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isAddRametCodesVisible: false,
            isImportRametCodesVisible: false,
            currentLayout: "Default"
        };

        accessToken = props.oidc.user.access_token;
        this.onContentReady = this.onContentReady.bind(this);
        this.AddRametCodesClick = this.AddRametCodesClick.bind(this);
        this.ImportRametCodesClick = this.ImportRametCodesClick.bind(this);
        this.handleClosePopUpCallback = this.handleClosePopUpCallback.bind(this);
        this.BlockDataSource = this.BlockDataSource.bind(this);
        this.LocationDataSource = this.LocationDataSource.bind(this);

        this.PositionEditorOptions = {
            format: {
                type: "#",
                min: 0,
                max: 3099
            },
        };
        this.OrderEditorOptions = {
            format: {
                type: "#",
                min: 0
            },
        };
        this.OrchardDataSource = createStore({
            key: "id",
            loadUrl: `${window._env_.REACT_APP_APIS}/${routes.Orchard.GetOrchardCodes}`,
            onBeforeSend: function (method, ajaxOptions) {
                ajaxOptions.headers = {
                    Authorization: `Bearer ${accessToken}`
                };
            }
        });
        this.dataSource = createStore({
            key: 'rowid',
            loadUrl: `${window._env_.REACT_APP_APIS}/${routes.RametCodes.GetAllRametCodes}`,
            updateUrl: `${window._env_.REACT_APP_APIS}/${routes.RametCodes.UpdateRametCode}`,
            deleteUrl: `${window._env_.REACT_APP_APIS}/${routes.RametCodes.DeleteRametCode}`,
            onBeforeSend: function (method, ajaxOptions) {
                ajaxOptions.headers = {
                    Authorization: `Bearer ${accessToken}`
                };
            }
        });
        this.userStatusDataSource = createStore({
            key: "code",
            loadUrl: `${window._env_.REACT_APP_APIS}/${routes.RametCodes.GetUserStatusCodes}`,
            onBeforeSend: function(method, ajaxOptions) {
              ajaxOptions.headers = {
                Authorization: `Bearer ${accessToken}`
              };
            }
          });
    }
    setCurrentLayout = (value) => {
        this.setState({ currentLayout: value });
    }
    loadState = () => {
        return GridLayout.sendStorageRequest(gridKey, "GET", accessToken, null, this.state.currentLayout);
    }
    saveState = (state) => {
        GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, this.state.currentLayout);
    }
    BlockDataSource(options) {
        return {
            store: createStore({
                key: "id",
                loadUrl: `${window._env_.REACT_APP_APIS}/${routes.Blocks.GetBlockCodes}`,
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            filter: options.data ? ['R_WareHouse', '=', options.data.orchard] : null
        };
    }
    LocationDataSource(options) {
        return {
            store: createStore({
                key: "id",
                loadUrl: `${window._env_.REACT_APP_APIS}/${routes.RametCodes.GetLocationCodes}`,
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            filter: options.data ?
                [['R_WareHouse', '=', options.data.orchard], "AND",
                ['R_Location', '=', options.data.block]]
                : null
        };
    }
    AddRametCodesClick() {
        this.setState({
            isAddRametCodesVisible: true,
        });
    }
    ImportRametCodesClick() {
        this.setState({
            isImportRametCodesVisible: true,
        });
    }
    setOrchardStateValue(rowData, value) {
        rowData.block = null;
        rowData.location = null;
        this.defaultSetCellValue(rowData, value);
    }
    setBlockStateValue(rowData, value) {
        rowData.location = null;
        this.defaultSetCellValue(rowData, value);
    }
    handleClosePopUpCallback() {
        this.setState({
            isAddRametCodesVisible: false,
            isImportRametCodesVisible: false
        });
        dataGrid.current.instance().refresh();
    };
    render() {
        return (
            <div className="h-100" >
                <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }} id="gridContainer"
                    onContentReady={this.onContentReady}
                    ref={dataGrid}
                    showBorders={true}
                    className="FullPageGridHeight"
                    rowAlternationEnabled={true}
                    allowColumnReordering={true}
                    allowColumnResizing={true}
                    columnAutoWidth={true}>
                    <Paging enabled={true} />
                    <Pager
                        visible={true}
                        showPageSizeSelector={true}
                        allowedPageSizes={allowedPageSizes}
                        showNavigationButtons={true}
                        showInfo={true} />
                    <FilterRow visible={true} />
                    <FilterPanel visible={true} />
                    <FilterBuilderPopup position={filterBuilderPopupPosition} />
                    <ColumnChooser
                        enabled={true}
                        title="Choose Column"
                        width={290}
                        height={290}
                        sortOrder="asc">
                        <ColumnChooserSearch
                            enabled={true}
                            editorOptions={{ placeholder: 'Search column' }} />
                    </ColumnChooser>
                    <HeaderFilter visible={true} />
                    <ColumnFixing enabled={true} />,
                    <Export enabled={true} allowExportSelectedData={true} text="Export" />
                    <Sorting mode="multiple" />
                    <Editing
                        mode="cell"
                        newRowPosition="first"
                        refreshMode="repaint"
                        allowUpdating={true}
                        allowAdding={true}
                        allowDeleting={true} />
                    <StateStoring
                        enabled={true}
                        type="custom"
                        customLoad={this.loadState}
                        storageKey={gridKey}
                        customSave={this.saveState}
                    />
                    <Column
                        dataField="orchard"
                        caption="Orchard Code" 
                        allowEditing={false}
                        cssClass="column-readonly"
                        setCellValue={this.setOrchardStateValue}>
                        <Lookup
                            displayExpr="name"
                            valueExpr="id"
                            dataSource={this.OrchardDataSource} />
                    </Column>
                    <Column
                        dataField="block"
                        caption="Block Code"
                        allowEditing={false}
                        cssClass="column-readonly"
                        setCellValue={this.setBlockStateValue}>
                        <Lookup
                            dataSource={this.BlockDataSource}
                            displayExpr="name"
                            valueExpr="id" />
                    </Column>
                    <Column dataField="location" caption="Location Code">
                        <Lookup
                            dataSource={this.LocationDataSource}
                            displayExpr="name"
                            valueExpr="id" />
                    </Column>
                    <Column dataField="code" caption="Ramet Code">
                        <RequiredRule message="Code(Ramet) is required." />
                        <StringLengthRule message="Code must have at least 3 chracters and maximum 20." min={3} max={20} />
                    </Column>
                    <Column dataField="description" caption="Description" visible={false}>
                        <StringLengthRule message="Description can have maximum 100 characters." max={100} />
                    </Column>
                    <Column dataField="orchardtype" caption="Orchard Type" visible={false}>
                        <Lookup
                            dataSource={OrchardTypeArr}
                            displayExpr="name"
                            valueExpr="value" />
                    </Column>
                    <Column dataField="elevation" caption="Elevation" visible={false}>
                        <Lookup
                            dataSource={ElevationArr}
                            displayExpr="name"
                            valueExpr="value" />
                    </Column>
                    <Column dataField="species" caption="Species" visible={false}>
                        <Lookup
                            dataSource={SpeciesArr}
                            displayExpr="name"
                            valueExpr="value" />
                    </Column>
                    <Column dataField="blockcycle" caption="Block Cycle" visible={false}>
                        <Lookup
                            dataSource={BlockCycleArr}
                            displayExpr="name"
                            valueExpr="value" />
                    </Column>
                    <Column dataField="stimcycle" caption="Stim Cycle" visible={false}>
                        <Lookup
                            dataSource={StimCycleArr}
                            displayExpr="name"
                            valueExpr="value" />
                    </Column>
                    <Column dataField="stimstatus" caption="Stim Status" visible={false}>
                        <Lookup
                            dataSource={StimStatusArr}
                            displayExpr="name"
                            valueExpr="value" />
                    </Column>
                    <Column dataField="breedingarea" caption="Breeding Area" visible={false}>
                        <Lookup
                            dataSource={BreedingAreaArr}
                            displayExpr="name"
                            valueExpr="value" />
                    </Column>
                    <Column dataField="rootstock" caption="Root Stock" visible={false}>
                        <StringLengthRule message="Root Stock can have maximum 20 characters." max={20} />
                    </Column>
                    <Column dataField="parent" caption="Parent" visible={false}>
                        <StringLengthRule message="Parent can have maximum 50 characters." max={50} />
                    </Column>
                    <Column dataField="graftdate" dataType="date" caption="Graft Date"></Column>
                    <Column dataField="plantdate" dataType="date" caption="Plant Date"></Column>
                    <Column dataField="userstatus" caption="User Status" visible={false}>
                        <Lookup
                            dataSource={this.userStatusDataSource}
                            displayExpr="description1"
                            valueExpr="code" />
                    </Column>
                    <Column dataField="posx" caption="Orchard Row" dataType="number" visible={false} allowEditing={false} cssClass="column-readonly"></Column>
                    <Column dataField="posy" caption="Orchard Col" dataType="number" visible={false} allowEditing={false} cssClass="column-readonly"></Column>
                    <Toolbar>
                        <Item location="before">
                            <Button onClick={this.AddRametCodesClick} text="Add Ramets" type="default" stylingMode="contained" className="margin-right" />
                        </Item>
                        <Item location="before">
                            <Button onClick={this.ImportRametCodesClick} text="Import Ramets" type="default" stylingMode="contained" className="margin-right" />
                        </Item>
                        <Item location="after">
                            <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={this.setCurrentLayout} />
                        </Item>
                        <Item name="exportButton" />
                        <Item name="columnChooserButton" />
                    </Toolbar>
                </DataGrid>
                {
                    this.state.isAddRametCodesVisible &&
                    <Popup
                        visible={this.state.isAddRametCodesVisible}
                        onHiding={this.handleClosePopUpCallback}
                        dragEnabled={false}
                        hideOnOutsideClick={true}
                        showCloseButton={true}
                        showTitle={true}
                        title="Add Ramets"
                        container="#root"
                        closeOnOutsideClick={true}
                        height={700}
                        width={900}>
                        <ScrollView width="100%" height="100%">
                            <AddRametCodes parentCallback={this.handleClosePopUpCallback}
                            ></AddRametCodes>
                        </ScrollView>
                    </Popup>
                }
                {
                    this.state.isImportRametCodesVisible &&
                    <Popup
                        visible={this.state.isImportRametCodesVisible}
                        onHiding={this.handleClosePopUpCallback}
                        dragEnabled={false}
                        hideOnOutsideClick={true}
                        showCloseButton={true}
                        showTitle={true}
                        title="Import Ramets"
                        container="#root"
                        closeOnOutsideClick={false}
                        height={700}
                        width={900}>
                        <ScrollView width="100%" height="100%">
                            <UploadRametCodes parentCallback={this.handleClosePopUpCallback}
                            ></UploadRametCodes>
                        </ScrollView>
                    </Popup>
                }
            </div>
        );
    }
    onContentReady(e) {
        if (!e.component._hasLoaded) {
            e.component._hasLoaded = true;
            e.component.option("dataSource", this.dataSource);
        }
    }
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(RametCodesGrid);